<template>
  <div id="rules" class="under-header padding-bottom">
    <div class="container">
      <div class="panel large">
        <h1 class="activity-title">Regles</h1>
      </div>
      <div class="panel large">
        <div style="text-align: justify;">
          <!-- <p>Here you can find the rules of the #bitsxLaMarató hackathon. They are a customised and simplified version of the standard rules used by the HackUPC hackathon (organised by HackersUPC). If you have any suggestions or questions about it, please send them here.</p> -->
          <div class="margin-bottom text-centered">
            <h2>L'esperit de bitsxlaMarató</h2>
          </div>
          <p class="margin-bottom"> Sigui quin sigui el motiu que t'ha portat a participar en aquesta hackató, assegura't de mantenir l'esperit no competitiu i col·laboratiu que aquest esdeveniment vol establir. Encara que hi ha premis pels equips guanyadors, el més important és tenir bons projectes per ajudar a la recerca de les malalties d'aquesta edició de la Marató de 3Cat.</p>
        </div>
      </div>
      <div class="panel large">
        <div style="text-align: justify;">
          <div class="margin-bottom text-centered">
            <h2>Regles de bitsxlaMarató</h2>
          </div>
          <div class="margin-bottom">
            <ol>
              <li>No hi ha nombre mínim de participants per equip, però si que hi ha un màxim: 4.</li><br/>
              <li>En cas de necessitar-ho, els equips poden demanar en tot moment ajuda als organitzadors, voluntaris, patrocinadors, mentors i, fins i tot, a altres equips.</li><br/>
              <li>El desenvolupament del projecte pot començar abans de la hackató.</li><br/>
              <li>Els equips poden utilitzar una idea d'abans de l'esdeveniment sempre que pugui encaixar amb un dels reptes plantejats.</li><br/>
              <li>Els equips poden utilitzar llibreries, frameworks o codi obert en el seu projecte.</li><br/>
              <li>Els projectes que trenquin el <i>Codi de Conducta</i> no estan autoritzats.</li><br/>
              <li>S'han de respectar les lleis de protecció de dades i de propietat intel·lectual.</li>
            </ol>
          </div>
        </div>
      </div>
      <div class="panel large">
        <div style="text-align: justify;">
          <div class="margin-bottom text-centered">
            <h2>Presentació projectes bitsxlaMarató</h2>
          </div>
          <p class="margin-bottom">
            Quan el temps de programació s'ha acabat, els equips han de presentar el seu projecte al lloc assignat.<br/><br/>
            Us demanem que presenteu en forma de demo del que heu creat i que compartiu els coneixements adquirits, no està permès presentar un PowerPoint, Figma, Canva o similar sense cap demo real.<br/><br/>
            T'animem a penjar a Devpost el projecte que has fet encara que no l'hagis pogut acabar; no és un problema si no has aconseguit el que volies, és comú a una hackató. La demo és una oportunitat d'ensenyar el que has après i el que has intentat crear, això és la màgia de les hackatons.<br/><br/>
            Només seràs apte a obtenir un premi si presentes el projecte (penjar-lo a Devpost i fer demo). Els premis s'avaluaran seguint el criteri de judging (el pots veure a la secció Judging d'aquesta pàgina).
          </p>
        </div>
      </div>
      <div class="panel large">
        <div style="text-align: justify;">
          <div class="margin-bottom text-centered">
            <h2>Recorda!</h2>
          </div>
          <p class="margin-bottom">
            Per fer d'aquest esdeveniment una experiència enriquidora, prova d'aprendre coses noves, ajuda als altres i fes amics.<br /><br />

            <i>Happy Hacking!</i> de part de l'equip de bitsxLaMarató
          </p>
        </div>
      </div>
      <div class="panel large">
        <h1 class="activity-title">JUDGING</h1>
      </div>
      <div class="panel large">
        <div style="text-align: justify;">
          <div class="margin-bottom text-centered">
            <h2>Tecnologia</h2>
          </div>
          <p class="margin-bottom">Què tan impressionant, tècnicament parlant, és la solució proposada pel repte?</p><br/>
          <p class="margin-bottom">Ha sigut difícil el problema tècnic que ha abordat l'equip?</p><br/>
          <p class="margin-bottom">Han utilitzat alguna tècnica especialment intel·ligent o han utilitzat molts components diferents?</p><br/>
          <p class="margin-bottom">La tecnologia utilitzada et fa tenir l'efecte "Wow"?</p>
        </div>
      </div>
      <div class="panel large">
        <div style="text-align: justify;">
          <div class="margin-bottom text-centered">
            <h2>Resolució del repte</h2>
          </div>
          <p class="margin-bottom">És la idea proposada una solució al repte?</p><br/>
          <p class="margin-bottom">És possible utilitzar aquest projecte per ajudar al desenvolupament del repte proposat?</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rules',
};
</script>

<style scoped>
</style>
